import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { CallToActionBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { salesSecondaryBlockDefaultStyles } from "../constants";
import { SalesBlock12 as Block } from "./SalesBlock12";
import { defaultData } from "./SalesBlock12DefaultData";
import imagePreview from "./sales_block_12_preview.png";

export const SalesBlock12: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Sales Block 12",
    nameI18n: "builder_ui.block_type.sales.block_12",
    version: 1,
    category: [CallToActionBlock],
    props: {
      header: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      button: {
        name: "Button",
        nameI18n: "builder_ui.prop_type.button",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      buttonDescription: {
        name: "Button description",
        nameI18n: "builder_ui.prop_type.button_description",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      footer: {
        name: "Footer",
        nameI18n: "builder_ui.prop_type.footer",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: salesSecondaryBlockDefaultStyles.backgroundColor,
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: salesSecondaryBlockDefaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: salesSecondaryBlockDefaultStyles.margin,
          },
        },
        type: "styles",
      },
    },
  },
};
